/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
export var ListItem = function ListItem(props) {
  var forgeDoc = props.forgeDoc,
    render = props.render;
  return jsx("li", {
    key: forgeDoc.key,
    children: forgeDoc.children.map(render)
  });
};